<template>
    <div class="top" data-aos="fade-up" data-aos-delay="100">
        <span>{{data.before}}</span>
        <div class="numbers" v-if="data.val.split(',').length === 1">
            <span class="number" v-for="number, index in data.val.length">
                <em :class="`show-${data.val[index]}`" v-for="i, ii in parseInt(data.val[index]) + 1">{{ii}}</em>
            </span>
        </div>
        <div class="numbers" v-else>
            <span class="number" v-for="number, index in data.val.split(',')[0].length">
                <em :class="`show-${data.val.split(',')[0][index]}`" v-for="i, ii in parseInt(data.val.split(',')[0][index]) + 1">{{ii}}</em>
            </span>
            <span class="comma">,</span>
            <span class="number" v-for="number, index in data.val.split(',')[1].length">
                <em :class="`show-${data.val.split(',')[1][index]}`" v-for="i, ii in parseInt(data.val.split(',')[1][index]) + 1">{{ii}}</em>
            </span>
        </div>
        <span>{{data.after}}</span>
    </div>

</template>

<script>
    export default {
        name: 'counter',
        props: ['data'],
        data() {
            return {}
        },
        methods: {
            
        },
        computed: {
          
        }
    }
</script>

<style scoped>
    .numbers {
        display: inline-block;
        vertical-align: bottom;
    }
    .comma {
        float: left;
    }
    .number {
        height: 1em;
        overflow: hidden;
        display: inline-block;
        vertical-align: bottom;
        float: left;
        transform: translateY(0);
    }
    .number em {
        display: block;
        transition: none;
    }
    .aos-animate .number em {
        transition: all 0.8s;
    }
    .number:nth-child(1) em {
        transition-delay: 0.2s;
    }
    .number:nth-child(2) em {
        transition-delay: 0.4s;
    }
    .number:nth-child(3) em {
        transition-delay: 0.6s;
    }
    .number:nth-child(4) em {
        transition-delay: 0.8s;
    }
    .number:nth-child(5) em {
        transition-delay: 1s;
    }
    .aos-animate .number .show-1 {
        transform: translateY(-100%);
    }
    .aos-animate .number .show-2 {
        transform: translateY(-200%);
    }
    .aos-animate .number .show-3 {
        transform: translateY(-300%);
    }
    .aos-animate .number .show-4 {
        transform: translateY(-400%);
    }
    .aos-animate .number .show-5 {
        transform: translateY(-500%);
    }
    .aos-animate .number .show-6 {
        transform: translateY(-600%);
    }
    .aos-animate .number .show-7 {
        transform: translateY(-700%);
    }
    .aos-animate .number .show-8 {
        transform: translateY(-800%);
    }
    .aos-animate .number .show-9 {
        transform: translateY(-900%);
    }
</style>


// WEBPACK FOOTER //
// Counter.vue?3e16cfa5